export interface TabConfig<T> {
  id: T;
  route: string;
  label: string;
  ariaLabel: string;
  isDisabled?: boolean;
}
